import { Component, OnInit } from '@angular/core';
import { ViewerControlInfoService } from '../viewer/viewer-control-info'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CommonControlService } from 'projects/data-portal/src/app/core/services/common-control.service';
import { CustomSortingService } from 'projects/data-portal/src/app/core/sort/custom-sorting.service';
import { SortableColumn } from 'projects/data-portal/src/app/core/sort/sortable-column';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseComponent } from 'projects/data-portal/src/app/core/components/base/base.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import {ViewerService} from '../../../../services/viewer-service';
import { AppConfigService } from '../../../../core/config/app-config.service';
import { ScannedDetails } from '../../../../models/scanned-details';

@Component({
  selector: 'app-viewer',
  templateUrl: './viewer.component.html',
  styleUrls: ['./viewer.component.css']
})
export class ViewerComponent extends BaseComponent implements OnInit {
  
  pageNumber: number = 1;
  itemsCount: number;
  pageSize: number = 50;
  sortColumn: string="SubmitDate"
  sortDirection: string="Desc"

  pageNumberScanned: number = 1;
  itemsCountScanned: number;
  pageSizeScanned: number = 10;
  sortColumnScanned: string="submitDate"
  sortDirectionScanned: string="Desc"

  gridPageStart: number = 1;
  gridPageEnd: number = 50;


  viewer: FormGroup;  
  scannedFB: FormGroup;  
  columns:string[];
  appealsData: any[];
  errorFromServer: boolean = false;
  formItems: any[];
  formItemScanned: any[];
  public searchCriteria: string = "";
  viewerFormGroup =[];
  scannedFormGroup =[];
  responseReceivedViewer: boolean = false;
  responseReceivedScanned: boolean = false;

  sortableColumns: Array<SortableColumn> = [
    new SortableColumn('RTN', 'RTN', null,'10%'),
    new SortableColumn('MainFormName', 'Form Name', null,'30%'),
    new SortableColumn('SubmitDate', 'Submit Date', null, '10%'),
    new SortableColumn(null, 'Attachments', null,'30%'),
    new SortableColumn('Notes', 'Notes', null, '10%'),
    new SortableColumn('DEPTrackingId', 'ID', null, '10%'),
  ];


  sortableColumnsScanned: Array<SortableColumn> = [
    new SortableColumn('rtn', 'RTN', null,'10%'),
    new SortableColumn('documentType', 'Document Type', null,'30%'),
    new SortableColumn('submitDate', 'Submit Date', null, '10%'),
    new SortableColumn('pages', 'Pages', null,'30%'),
    new SortableColumn('fileName', 'File Name', null, '10%')
  ];


  constructor(private fb: FormBuilder,
    private router: Router, 
    private route: ActivatedRoute , 
    private SpinnerService: NgxSpinnerService,
    private service: ViewerControlInfoService,
    private commonControlService: CommonControlService,
    private customSortingService: CustomSortingService,
    private modalService: BsModalService,
    private viewerService: ViewerService
    ) {
      super(modalService)
    }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
      ngOnInit(): void {
       
      
        this.formItems = this.service.getViewerProperties();
        this.viewer =this.commonControlService.toFormGroup(this.formItems);
        this.createFormElectrically(this.pageNumber, this.pageSize);
      }
      electrically_pageCountChanged(event): void{
        
        this.pageNumber = 1;
        this.pageSize = event.target.value;
        this.createFormElectrically(this.pageNumber, this.pageSize);
        this.gridFooter(this.pageNumber, this.pageSize);
      }
      electrically_pageChanged(event: PageChangedEvent): void {
        
          this.pageNumber = event.page;
          this.createFormElectrically(this.pageNumber, this.pageSize);
          this.gridFooter(this.pageNumber, this.pageSize);
      }
    
      private createFormElectrically(pageNumber: number, pageSize: number): void {  
        
        this.electricallyViewerSearch(); 
      }

  
    

    electricallyViewerSearch() {
      this.SpinnerService.show();
      var rtn = this.route.snapshot.paramMap.get('rtn')
      this.viewerService.getElectronicallySubmittedDetails(rtn,this.sortColumn,this.sortDirection,this.pageNumber,this.pageSize).subscribe((data: any[]) => {
        if(data.length!=0)
        {
          this.viewerFormGroup =data['electricallySubmittedResponse'];
          this.itemsCount = data['totalCount'];
        }
        this.responseReceivedViewer=true;
        this.gridFooter(this.pageNumber, this.pageSize);
        this.SpinnerService.hide();
      },(err) => {
        this.SpinnerService.hide();
        alert("Internal Server Error - Something went Wrong");
      }
      );
    }

    public electrically_sort(sortableColumn: SortableColumn): void {
      sortableColumn.toggleDirection();
      this.customSortingService.clearPreviousSorting(sortableColumn, this.sortableColumns);
      this.sortColumn=sortableColumn.name;
      this.sortDirection=sortableColumn.direction;
      this.electricallyViewerSearch();
    }

    back(){
      window.history.back();
    }

    changeRoute(fileEncryptionId:String)
    {
      
    }

    gridFooter(pageNumber: number, pageSize: number)
  {
    if(pageNumber!=1)
    {
      this.gridPageStart = (pageSize * (pageNumber -1 )) + 1
    }
    else{
      this.gridPageStart = 1;
    }

    if(this.itemsCount >= (pageNumber * pageSize))
    {
       this.gridPageEnd = (pageNumber * pageSize) ;
    }
    else{
      this.gridPageEnd =this.itemsCount ;
    }
  }

}
